/**
 * Service DPI live (POC vocal « Saisie », US-VDPI-06).
 * Vue fusionnée référence (pmsi) + saisies + journal — endpoint authentifié (JWT).
 */

import { apiClient } from '@/shared/services/apiClient';
import { API_ENDPOINTS } from '@/config/api';
import type { ChambreOut, DpiView, MenuOut, SaisieIn, SaisieOut } from '@/shared/types/dpi';

export const dpiService = {
  getDpi: (): Promise<DpiView> => apiClient.get<DpiView>(API_ENDPOINTS.dpi),

  // ── Dialogue guidé (US-VDPI-03) ─────────────────────────────────────────────

  /** GET /api/v1/dpi/chambres/{numero} — 404/erreur → null (chambre inexistante). */
  async chambre(numero: string): Promise<ChambreOut | null> {
    try {
      return await apiClient.get<ChambreOut>(API_ENDPOINTS.dpiChambre(numero));
    } catch {
      return null;
    }
  },

  /** GET /api/v1/dpi/patient/{id}/menu — menu lettré contextuel. */
  menu: (patientId: string): Promise<MenuOut> =>
    apiClient.get<MenuOut>(API_ENDPOINTS.dpiMenu(patientId)),

  /** POST /api/v1/dpi/saisie — écriture d'une saisie clinique. */
  saisie: (payload: SaisieIn): Promise<SaisieOut> =>
    apiClient.post<SaisieOut>(API_ENDPOINTS.dpiSaisie, payload),
};
